import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const BarChart = ({ data }) => {
  return (
    <ResponsiveBar
      data={data.values}
      colors={data.colors}
      keys={data.keys}
      indexBy={data.indexBy}
      margin={{ top: 60, right: 10, bottom: 50, left: 60 }}
      padding={0.3}
      borderWidth={1}
      borderRadius={5}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.8]],
      }}
      innerPadding={3}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      defs={[
        {
          id: "linear",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={data.fill}
      onClick={(a) => {
        if (data.onClick) {
          data.onClick(a);
        }
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: "middle",
        legendOffset: 32,
        ...data.axisBottom,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Tareas",
        legendPosition: "middle",
        legendOffset: -40,
        ...data.axisLeft,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "center-top",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: -50,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      // ariaLabel="Nivo bar chart demo"
      barAriaLabel={(e) => `${e.id}: ${e.formattedValue} in mes: ${e.indexValue}`}
    />
  );
};

export default BarChart;
